import ApiService from "./ApiService";

class WebinarRESTService extends ApiService {
    constructor() {
        super();
        this.endpoint = 'v1/wbi';
    }

    async getWebinarsList(dto = {}){
        const query = {};
        if (dto.page != null) query.page = dto.page;
        if (dto.perPage != null) query.perPage = dto.perPage;
        if (dto.type != null) query.type = dto.type;
        if (dto.eligibilityLevel != null) query.eligibilityLevel = dto.eligibilityLevel;
        if (dto.exam != null) query.exam = dto.exam;
        if (dto.tags != null && dto.tags.length > 0) query.tags = dto.tags.join(',');
        if (dto.region != null) query.region = dto.region;
        return await this.get(`${this.endpoint}/webinars`, query);
    }

    async getWebinarItem(id){
        return await this.get(`${this.endpoint}/webinars/${id}`);
    }

    async createRegistration(payload){
        return await this.post(`${this.endpoint}/register`, payload);
    }

    async cancelRegistration(payload){
        return await this.post(`${this.endpoint}/register/cancel`, payload);
    }

    async getFIlters(){
        return await this.get(`${this.endpoint}/filters`);
    }

    async getWebinarsCountByExam(){
        return await this.get(`${this.endpoint}/webinars/count-by-exam`);
    }

    // async test(data){
    //     return await this.post(`${this.endpoint}/test/post` , data);
    // }
}

export default WebinarRESTService;



// WEBPACK FOOTER //
// ./src/services/WebinarRESTService.js